<app-navbar></app-navbar>

<div class="container-fluid course-page">
  <div class="row">
    <nav class="col-md-3 col-lg-2 d-md-block sidebar course-sidebar">
      <div class="sidebar-sticky">
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link" routerLink="/electric-cars">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Electric Cars</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/design-and-manufacturing">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Design and Manufacturing</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/auto-electrical">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Auto Electrical of an Electric Scooter</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/iot">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Internet of Things</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/charger-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Charger Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/solar-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Solar Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/welding">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Welding</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <main role="main" class="col-md-9 col-lg-10 ms-sm-auto px-3 px-md-4 py-4 course-content">
      <section class="course-header">
        <p class="course-tag">FEA Course</p>
        <h1>Female Engineers Academy - Speed Control System</h1>
        <p class="course-subtitle">Learn through guided lessons and complete the module resources and progress checkpoints.</p>
      </section>

      <section class="lesson-grid">
        <article class="lesson-card">
          <h4><span>01</span> Lesson 01</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/videos%2FSpeed-Control-System%2FSFEA_Intro_fin_%20Erica%201.mp4?alt=media&token=a56fa560-14d7-4ba2-b230-e250c6191f32" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>02</span> Lesson 02</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/videos%2FSpeed-Control-System%2FSFEA_Intro_fin_%20Erica%202.mp4?alt=media&token=01be34b4-29ca-4ff6-9fe9-bb49d08ecb65" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>03</span> Lesson 03</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/videos%2FSpeed-Control-System%2FSFEA_Intro_fin_%20erica%203.mp4?alt=media&token=3279fd1c-b3b0-42ae-9099-4a4495589833" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>04</span> Lesson 04</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/videos%2FSpeed-Control-System%2FSFEA_Intro_fin_%20Erica%204.mp4?alt=media&token=e743b277-8c44-490e-97ef-5235154a9e1a" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>05</span> Lesson 05</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/videos%2FSpeed-Control-System%2FSFEA_Intro_fin_%20Erica%205.mp4?alt=media&token=2baec00f-c987-4305-b39e-1a06450cf982" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>06</span> Lesson 06</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/videos%2FSpeed-Control-System%2FSFEA_Intro_fin_%20Erica%206.mp4?alt=media&token=d0b85a51-eca7-49f8-b5a5-b1e6611866f0" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>07</span> Lesson 07</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/videos%2FSpeed-Control-System%2FSFEA_Intro_fin_%20Erica%207.mp4?alt=media&token=552f05ac-dfe3-4330-ac85-a188b51a4525" type="video/mp4">
          </video>
        </article>

      </section>

      <section class="course-actions">
        <a class="btn solarorange" href="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/course-slides%2FSPEED%20CONTROL%20SYSTEM.pdf?alt=media&token=75a5b663-0c6a-4d58-84d4-2f1f1ea8071b" target="_blank" rel="noopener noreferrer">
          Download Course Material
        </a>

        <button type="button" class="btn solarorange complete-btn" (click)="completed()">
          Mark Completed
        </button>
      </section>
    </main>
  </div>
</div>
